import { InputState } from '@kubit/web-ui-components/input/types';
import { ListOptionVariantType } from '../../listOptions/variants';
import { OptionVariantType } from '../../option/variants';
import { commonStyles } from '../commonStyles';
import { InputSearchVariant } from '../variants';
export const getDefaultStyles = (FOUNDATIONS, FONT) => ({
    [InputSearchVariant.DEFAULT]: {
        [InputState.ACTIVE]: {
            ...commonStyles(FOUNDATIONS),
        },
        [InputState.FILLED]: {
            ...commonStyles(FOUNDATIONS),
        },
        [InputState.DISABLED_EMPTY]: {
            ...commonStyles(FOUNDATIONS),
        },
        [InputState.DISABLED_FILLED]: {
            ...commonStyles(FOUNDATIONS),
        },
        [InputState.DISABLED_FILLED_WITH_INFO]: {
            ...commonStyles(FOUNDATIONS),
        },
        [InputState.EMPTY]: {
            ...commonStyles(FOUNDATIONS),
        },
        [InputState.ERROR_ACTIVE]: {
            ...commonStyles(FOUNDATIONS),
        },
        [InputState.ERROR_EMPTY]: {
            ...commonStyles(FOUNDATIONS),
        },
        [InputState.ERROR_FILLED]: {
            ...commonStyles(FOUNDATIONS),
        },
        [InputState.ERROR_FILLED_WITH_INFO]: {
            ...commonStyles(FOUNDATIONS),
        },
        listOptions: {
            variant: ListOptionVariantType.DEFAULT,
            optionVariant: OptionVariantType.SELECTOR_ROW_DEFAULT,
            hightlightedOptionVariant: OptionVariantType.SELECTOR_ROW_DEFAULT,
        },
    },
});
//# sourceMappingURL=default.js.map